import { render, staticRenderFns } from "./SystemRestrictionModal.vue?vue&type=template&id=e4197dbe&scoped=true&"
import script from "./SystemRestrictionModal.vue?vue&type=script&lang=js&"
export * from "./SystemRestrictionModal.vue?vue&type=script&lang=js&"
import style0 from "./SystemRestrictionModal.vue?vue&type=style&index=0&id=e4197dbe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4197dbe",
  null
  
)

export default component.exports